import React                            from 'react';

const useGetGreeting = () => {
   
      const greeting = React.useMemo(() => {

        const url_string = window.location.href;
        const url        = new URL(url_string);
        const greeting   = url.searchParams.get("greeting");

        if (!greeting) {
          return "";
        }
      
        let decodedGreeting = '';
        const arr           = greeting.split(',').map((val: string) => { return +val })
        decodedGreeting     = String.fromCharCode.apply(null, arr)

        return decodedGreeting;
     
      },[])

      return greeting;
}


export default useGetGreeting;











